import React, { Fragment, useContext, useState } from "react";
import {  useNavigate } from "react-router-dom";
import CountryStateCitySelector from "../../Lib/CountryStateCitySelector";
import useFormVessOwner from "../Libs/useVessel";
import { AuthContext } from "../../Context/AuthContext";  
import { toast, ToastContainer } from "react-toastify";
import useVesselOwnerForm from "../Libs/useVesselOwnerFrom";
import axios from "axios";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";

const CreateProfleStepTwo = () => {
  const { logout, token } = useContext(AuthContext);
  const { formDatas } = useVesselOwnerForm();
  const { handleChange, handleSubmit, loading, formData, error, success } = useFormVessOwner();
  const navigate = useNavigate()
  const [saving, setSaving] = useState(false);


  // Function to handle save and logout
  const handleSaveLogout = async () => {
    setSaving(true); 
    try {
      const requestData = {
        companyName: formDatas.companyName,
        registrationNumber: formDatas.registrationNumber,
        address: formData.address,
        state: formData.state,
        city: formData.city,
        country: formData.country,
        phoneNumber: formDatas.phoneNumber,
        yearsInOperation: parseInt(formDatas.yearsInOperation),
        website: formDatas.website,
        linkedIn: formDatas.linkedIn,
        serviceCategory: formDatas.serviceCategory,
        keywords: formDatas.keywords,
      };

      const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/vesselOwner/profile`, requestData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        logout();
        toast.success("Profile saved successfully. You are logged out!");
      }
    } catch (error) {
      console.error(error.message);
      toast.error('Error saving profile data!');
    } finally {
      setSaving(false);  
    }
  };

  return (
    <Fragment>
      <ToastContainer />  
      <div className="customer-active-container">
        <div className="wrap">
        <div className="header">
          <button onClick={() => navigate("/createprofile_step_1")}>
            Back
          </button>
          <BlackVatugIcon onClick={() => navigate("/")}/>
          <button 
            className="finished" 
            onClick={handleSaveLogout} 
            disabled={saving}  
            >
            {saving ? "Saving & Log out" : "Save & Log out"}  
          </button>
            </div>
        </div>
        <form onSubmit={handleSubmit}>
          <h2>Customer Information</h2>
          <p>
            Please enter the name as it appears on a government-issued certificate
            or Bank Statement
          </p>

         <CountryStateCitySelector
            formData={formData}
            handleInputChange={handleChange}
            disableCountrySelection={true}
          />

          <label>
           Business Address
            <textarea
              placeholder="Enter address"
              name="address"
              value={formData.address}
              onChange={handleChange}
            ></textarea>
          </label>

          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Next"}
          </button>
          {error && <p style={{ margin: "auto", color: "red" }}>{error}</p>}
          {success && <p style={{ margin: "auto", color: "green" }}>{success}</p>}
        </form>
      </div>
    </Fragment>
  );
}

export default CreateProfleStepTwo;
